/* global axios */
import ApiClient from '../ApiClient';

class ArrowsAiResourcesAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/resources`);
  }

  create({ assistantId, files } = {}) {
    const body = new FormData();
    Array.from(files || []).forEach(file => body.append('files[]', file));
    return axios.post(`${this.url}/${assistantId}/resources`, body);
  }

  update({ assistantId, id, payload } = {}) {
    return axios.patch(`${this.url}/${assistantId}/resources/${id}`, {
      resource: {
        name: payload.name,
        description: payload.description,
      },
    });
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/resources/${id}`);
  }
}

export default new ArrowsAiResourcesAPI();
